export const statusType = {
  idle: 'idle',
  loading: 'loading',
  error: 'error',
  success: 'success',
}
